const named = (name, component) => {
  const renamed = component;
  renamed.displayName = name;
  renamed.whyDidYouRender = true;
  return renamed;
};
export {
  named
};
